import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.75 3.5A2.25 2.25 0 0 0 6.5 5.75v10.5a2.25 2.25 0 0 0 2.25 2.25h8.5a2.25 2.25 0 0 0 2.25-2.25V5.75a2.25 2.25 0 0 0-2.25-2.25zM5 5.75A3.75 3.75 0 0 1 8.75 2h8.5A3.75 3.75 0 0 1 21 5.75v10.5A3.75 3.75 0 0 1 17.25 20h-8.5A3.75 3.75 0 0 1 5 16.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.25 8.75A2.25 2.25 0 0 0 2 11v7.25A3.75 3.75 0 0 0 5.75 22H13a2.25 2.25 0 0 0 2.25-2.25v-.5a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 1-.75.75H5.75a2.25 2.25 0 0 1-2.25-2.25V11a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }